module.exports = __webpack_public_path__ + "img/image_gallery1.49505824.jpg";